<template>
  <div class="content-page" v-if="productInfo.length">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/marketing' }">营销管理</el-breadcrumb-item>
        <el-breadcrumb-item
          >{{ productList[userFuncType - 1].name }}订购</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <div class="top-container">
        <div class="item">
          <img :src="productList[userFuncType - 1].img" alt />
          <div class="info">
            <p class="title">{{ productList[userFuncType - 1].name }}</p>
            <p class="desc">{{ productList[userFuncType - 1].content }}</p>
          </div>
        </div>
        <div class="price-info">
          <p class="price">
            服务价格：
            <span class="num">￥{{ productInfo[current].price.toFixed(2) }}</span>
          </p>
          <div class="price-box">
            <el-radio-group v-model="current" size="medium">
              <el-radio
                :label="index"
                border
                v-for="(item, index) in productInfo"
                :key="index"
                >{{ item.dayCount }}天</el-radio
              >
            </el-radio-group>
            <el-button type="danger" @click="openOrderConfirmDialog">立即订购</el-button>
          </div>
        </div>
      </div>
      <div class="common-container" v-if="userFuncType != 3 && userFuncType != 4">
        <p class="title">推荐套餐</p>
        <div class="content">
          <div class="setmeal-info">
            <img :src="productList[0].img" alt />
            <span class="symbol">+</span>
            <img :src="productList[1].img" alt />
            <span class="symbol">=</span>
            <span class="price">{{
              seatMealProductInfo.length > current
                ? `￥${seatMealProductInfo[current].price.toFixed(2)}`
                : "暂无价格"
            }}</span>
            <el-button type="primary" @click="linkToSetMeal">立即订购</el-button>
          </div>
        </div>
      </div>
      <div class="common-container">
        <p class="title">详情介绍</p>
        <div class="content">
          <div class="details" v-if="userFuncType == 1 || userFuncType == 3">
            <img src="@/assets/img/marketing/takeout-img1.png" alt />
            <img src="@/assets/img/marketing/takeout-img2.png" alt />
            <img src="@/assets/img/marketing/takeout-img3.png" alt />
          </div>
          <div class="details" v-if="userFuncType == 2 || userFuncType == 3">
            <img src="@/assets/img/marketing/tang-img1.png" alt />
            <img src="@/assets/img/marketing/tang-img2.png" alt />
            <img src="@/assets/img/marketing/tang-img3.png" alt />
          </div>
          <div class="details" v-if="userFuncType == 4">
            <img src="https://www.163.gg/images/site/wf_web02/nuber-img.jpg" alt />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
      :visible.sync="dialogOrderPayVisible"
      @close="resetData"
    >
      <div slot="title" class="dialog-title">确认订单信息</div>
      <el-form label-width="88px" class="orderpay-form">
        <el-form-item label="开通商品">
          <p class="title">{{ productInfo[current].title }}</p>
        </el-form-item>
        <el-form-item label="开通商家">
          <el-input :value="shop.shopName" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付金额">
          <p class="price">￥{{ productInfo[current].price.toFixed(2) }}</p>
        </el-form-item>
        <el-form-item label="支付方式">
          <div class="paymethod">
            <p>在线支付</p>
            <el-checkbox v-model="checked">
              我已经阅读并同意
              <el-link type="primary" :underline="false"
                >《码点餐订购及服务协议》</el-link
              >
            </el-checkbox>
          </div>
        </el-form-item>
        <!-- <el-form-item label="备注">
                    <el-input type="textarea" v-model="remarks" :rows="4" placeholder="备注信息"></el-input>
                </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createOrder">立即创建</el-button>
        <el-button @click="dialogOrderPayVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUserFuncProductList, buyUserFunc, getTransactionInfo } from "@/api/index.js";

export default {
  data() {
    return {
      productInfo: [],
      seatMealProductInfo: [],
      current: 0,
      userFuncType: 0,
      dialogOrderPayVisible: false,
      remarks: "",
      checked: false,
    };
  },
  created() {
    this.userFuncType = this.$route.query.userFuncType;
  },
  computed: {
    ...mapState({
      productList: (state) => state.productsList[0].list,
      shop: (state) => state.shopInfo,
    }),
  },
  watch: {
    userFuncType() {
      this.getProductInfo();
    },
  },
  mounted() {},
  methods: {
    getProductInfo() {
      getUserFuncProductList({
        userFuncType: this.userFuncType,
      }).then((res) => {
        if (res.code == 1) {
          this.productInfo = res.data;
        }
        if (this.userFuncType != 3 || this.userFuncType != 4) {
          getUserFuncProductList({
            userFuncType: this.userFuncType,
          }).then((res) => {
            if (res.code == 1) {
              this.seatMealProductInfo = res.data;
            }
          });
        }
      });
    },
    createOrder() {
      if (!this.checked) {
        this.$notify({
          title: "警告",
          message: "请阅读并同意《码点餐订购及服务协议》",
          type: "warning",
        });
        return;
      }
      buyUserFunc({
        userFuncProductId: this.productInfo[this.current].id,
      }).then((res) => {
        if (res.code == 1) {
          getTransactionInfo({
            orderNumber: res.data.orderNumber,
          }).then((orderData) => {
            if (orderData.code == 1) {
              window.open(
                `https://api.163.gg/pay/WebWfOrder_userPay?tranOrderId=${orderData.data.tranOrderId}`
              );
            } else {
              this.$notify({
                title: "提示",
                message: orderData.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    linkToSetMeal() {
      this.userFuncType = 3;
    },
    openOrderConfirmDialog() {
      this.dialogOrderPayVisible = true;
    },
    resetData() {
      this.checked = false;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .dialog-footer {
    padding-bottom: 30px;
  }
}
.tab-content {
  display: block;
  padding: 20px;
  .top-container {
    width: 100%;
    background: #f8f8f8;
    padding: 20px;
    box-sizing: border-box;
    .item {
      display: flex;
      width: 260px;
      height: 54px;
      align-items: center;
      cursor: pointer;
      transition: all 0.5s;
      & > img {
        width: 44px;
        height: 44px;
        margin: 0 10px 0 0;
        object-fit: contain;
      }
      .info {
        & > p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 180px;
        }
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #333333;
          margin-bottom: 12px;
          font-weight: bold;
        }
        .desc {
          font-size: 12px;
          line-height: 12px;
          color: #999999;
        }
      }
    }
    .price-info {
      margin: 0 0 0 54px;
      .price {
        font-size: 12px;
        color: #666666;
        margin: 24px 0 42px 0;
        .num {
          font-size: 18px;
          color: #ff3a3a;
          font-weight: bold;
        }
      }
      .price-box {
        .el-radio {
          margin-right: 20px;
          margin-left: 0;
        }
      }
    }
  }
  .common-container {
    .title {
      font-size: 14px;
      line-height: 56px;
      color: #333333;
      font-weight: bold;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 10px;
    }
    .setmeal-info {
      color: #409eff;
      font-size: 24px;
      line-height: 44px;
      height: 44px;
      margin-bottom: 2px;
      img {
        vertical-align: middle;
      }
      .symbol {
        margin: 0 20px;
      }
      .price {
        font-size: 24px;
        color: #fc7f0d;
      }
      .el-button {
        vertical-align: middle;
        margin-left: 32px;
      }
    }
    .details {
      img {
        display: block;
        width: 750px;
      }
    }
  }
}
</style>

<style lang="less">
.orderpay-form {
  .el-form-item {
    margin-bottom: 0;
  }
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
  .price {
    font-size: 14px;
    color: #ff3a3a;
  }
}
</style>
